/**
 * V2 Global 3D Tracking Engine
 * Attaches the Deep Earth magnetic physics to any element with the .v2-magnetic-glass class across the entire store.
 */
document.addEventListener('DOMContentLoaded', () => {
  // Activate global body theme markers if needed
  if (!document.body.classList.contains('v2-enabled')) {
    document.body.classList.add('v2-enabled');
  }

  // Pure 3D Hardware Physics Init
  initV2Physics();

  // Watch for dynamic injections (like infinite scroll or Ajax cart)
  const observer = new MutationObserver((mutations) => {
    let newCardsFound = false;
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.classList.contains('v2-magnetic-glass') || node.querySelector('.v2-magnetic-glass'))) {
            newCardsFound = true;
          }
        });
      }
    });

    if (newCardsFound) {
      initV2Physics();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

function initV2Physics() {
  const cards = document.querySelectorAll('.v2-magnetic-glass');
  
  cards.forEach(card => {
    // Prevent double-binding
    if(card.dataset.v2Bound) return;
    card.dataset.v2Bound = "true";

    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left; 
      const y = e.clientY - rect.top;

      // Calculate tilt based on cursor coordinates
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const rotateX = ((y - centerY) / centerY) * -8; // Pitch
      const rotateY = ((x - centerX) / centerX) * 8;  // Yaw

      // GPU hardware trigger translation
      card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
      
      // Update dynamic Glare position
      let glare = card.querySelector('.v2-glare');
      if(glare) {
        glare.style.setProperty('--v2-mouse-x', `${(x / rect.width) * 100}%`);
        glare.style.setProperty('--v2-mouse-y', `${(y / rect.height) * 100}%`);
      }
    });

    card.addEventListener('mouseleave', () => {
      card.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)`;
    });
  });
}
